import React, { Component } from "react";
import PropTypes from "prop-types";

const CDCNoteContext = React.createContext();

const { Consumer, Provider } = CDCNoteContext;

class CDCNoteManager extends Component {
  static propTypes = {
    children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  };

  onNoteChange = value => {
    this.setState({ noteInfo: value });
  };

  state = {
    noteInfo: "",
    onNoteChange: this.onNoteChange,
  };

  render() {
    return (
      <Provider value={this.state}>
        {typeof this.props.children === "function" ? this.props.children(this.state) : this.props.children}
      </Provider>
    );
  }
}

export { Consumer as CDCConsumer, CDCNoteManager, CDCNoteContext };
